import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();

// Suporte a basename do Vite (para deploy em subpaths)
const basename = import.meta.env.BASE_URL || "/";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App basename={basename} />
  </HelmetProvider>,
);
